// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EHTB","largestCol":"styles_largestCol__3BwHq","smallestCol":"styles_smallestCol__22qs0"};